import React, {Suspense, useCallback, useEffect, useRef, useState} from 'react';
import {NumericFormat} from "react-number-format";
import "react-spring-modal/styles.css";
import useWindowDimensions from "../Wedgits/useWindowDimensions";
import {BottomModal, ExpandModal} from "react-spring-modal";
import axios from "axios";
import PreviewPage from "./PreviewPage";
import "../Css/Container.scss";
import HomePage from "./HomePage";
import {Navigate, Route, Routes, useNavigate} from "react-router-dom";
import LoadingSpinner from "../Wedgits/LoadingSpinner";

function Container(props) {

    const [isLoggedIn, setIsLoggedIn] = useState(
        localStorage.getItem("token") != null
    );

    const navigate = useNavigate();

    // axios.defaults.baseURL = 'http://192.168.2.12:1234';
    axios.defaults.baseURL = "https://api.mealland.ir";
    axios.defaults.url = "17220700380eae0beb";
    // axios.defaults.url = "1719730216e09a1ff1";

    const {height, width} = useWindowDimensions();

    const [isFetchOver, setIsFetchOver] = useState(false);
    const [isPreviewIsOver, setIsPreviewIsOver] = useState(false);
    const swiperRef = useRef(null);

    const [selectedPageTitle, setSelectedPageTitle] = useState("MenuContent");

    const [isSwiped, setIsSwiped] = useState(false);

    const [sidebarIsOpen, setSidebarIsOpen] = useState(false);

    const scrollToElement = (id) => {
        const element = document.getElementById(id);
        if (element) {
            swiperRef.current.swiper.slideNext(); // Go to the next slide
            setTimeout(() => {
                element.scrollIntoView({behavior: 'smooth', block: "center", inline: "center"});
            }, 1000);
        }
    };

    useEffect(() => {
        setTimeout(() => {
            setIsPreviewIsOver(true);
        }, 2000);
    }, []);

    const staticStyles = {
        position: 'absolute',
        top: 0,
        right: 0,
        borderRadius: '0.25rem',
        padding: 0,
        height: "100%",
        width: "200px",
        zIndex: 1030,
        opacity: "1"
    };

    const HomePage = React.lazy(() => import('./HomePage'));
    const MenuPage = React.lazy(() => import('./MenuContent'));

    return (
        <div className="pagesContainer">
            <BottomModal
                isOpen={sidebarIsOpen}
                contentTransition={{
                    from: {transform: 'translateX(100%)'},
                    enter: {transform: 'translateX(0)'},
                    leave: {transform: 'translateX(100%)'}
                }}
                overlayProps={{style: {zIndex: 1040, opacity: 1}}}
                contentProps={{style: staticStyles}}>
                <div className="sideBarContainer">
                    <div className="closeModalContainer">
                        <button className="" onClick={() => {
                            setSidebarIsOpen(false)
                        }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"
                                 fill="none">
                                <rect y="4.43604" width="6.2735" height="32.0646" rx="3.13675"
                                      transform="rotate(-45 0 4.43604)" fill="white"/>
                                <rect x="22.6731" width="6.2735" height="32.0646" rx="3.13675"
                                      transform="rotate(45 22.6731 0)" fill="white"/>
                            </svg>
                        </button>
                    </div>
                    <div className="optionsContainer">
                        <button onClick={() => {
                            navigate("/")
                            setTimeout(() => {
                                scrollToElement("textContainerId");
                            }, 500);
                            setTimeout(() => {
                                setIsSwiped(true);
                            }, 1500);
                            setSidebarIsOpen(false)
                        }}> درباره آبنوس
                        </button>
                        <button onClick={() => {
                            if (window.location.pathname != "/menu") {
                                navigate("/")
                                setTimeout(() => {
                                    scrollToElement("menuContainerId");
                                }, 500);
                                setTimeout(() => {
                                    setIsSwiped(true);
                                }, 1500);
                                setSidebarIsOpen(false)
                            }
                        }}> منو آبنوس
                        </button>
                        <button onClick={() => {
                            navigate("/")
                            setTimeout(() => {
                                scrollToElement("galleryContainerId");
                            }, 500);
                            setTimeout(() => {
                                setIsSwiped(true);
                            }, 1500);
                            setSidebarIsOpen(false)
                        }}> تصاویر
                        </button>
                        <button onClick={() => {
                            navigate("/")
                            setTimeout(() => {
                                scrollToElement("conractUsId");
                            }, 500);
                            setTimeout(() => {
                                setIsSwiped(true);
                            }, 1500);
                            setSidebarIsOpen(false)
                        }}> تماس با ما
                        </button>
                    </div>
                    <p className="linksContainer">
                                <span>
                                    <a href="https://maps.app.goo.gl/nk9UdfBuz7zqjkje6" target={"_blank"}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="30"
                                             viewBox="0 0 22 30" fill="none">
                                      <path
                                          d="M11 0C4.92643 0 0 4.68011 0 10.45C0 18.2875 11 29.8571 11 29.8571C11 29.8571 22 18.2875 22 10.45C22 4.68011 17.0736 0 11 0ZM11 14.1821C8.83143 14.1821 7.07143 12.5101 7.07143 10.45C7.07143 8.38986 8.83143 6.71786 11 6.71786C13.1686 6.71786 14.9286 8.38986 14.9286 10.45C14.9286 12.5101 13.1686 14.1821 11 14.1821Z"
                                          fill="white"/>
                                    </svg>
                                    </a>

                                </span>
                        <span>
                                      <a href="https://www.instagram.com/abnous.restaurant" target={"_blank"}>
                                          <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31"
                                               viewBox="0 0 31 31"
                                               fill="none">
                                    <path
                                        d="M15.418 9.13051C11.5908 9.13051 8.41975 12.2469 8.41975 16.1287C8.41975 20.0106 11.5362 23.127 15.418 23.127C19.2998 23.127 22.4162 19.9559 22.4162 16.1287C22.4162 12.3016 19.2452 9.13051 15.418 9.13051ZM15.418 20.612C12.9577 20.612 10.9347 18.5891 10.9347 16.1287C10.9347 13.6684 12.9577 11.6455 15.418 11.6455C17.8783 11.6455 19.9012 13.6684 19.9012 16.1287C19.9012 18.5891 17.8783 20.612 15.418 20.612Z"
                                        fill="white"/>
                                    <path
                                        d="M22.6896 10.552C23.5653 10.552 24.2751 9.84216 24.2751 8.96649C24.2751 8.09082 23.5653 7.38095 22.6896 7.38095C21.8139 7.38095 21.1041 8.09082 21.1041 8.96649C21.1041 9.84216 21.8139 10.552 22.6896 10.552Z"
                                        fill="white"/>
                                    <path
                                        d="M26.7901 4.86596C25.3686 3.38977 23.3457 2.62434 21.0494 2.62434H9.7866C5.02999 2.62434 1.85891 5.79541 1.85891 10.552V21.7601C1.85891 24.1111 2.62434 26.134 4.15521 27.6102C5.6314 29.0317 7.59965 29.7425 9.84127 29.7425H20.9947C23.3457 29.7425 25.3139 28.9771 26.7355 27.6102C28.2116 26.1887 28.9771 24.1658 28.9771 21.8148V10.552C28.9771 8.25573 28.2116 6.28748 26.7901 4.86596ZM26.5714 21.8148C26.5714 23.5097 25.97 24.8765 24.9859 25.806C24.0018 26.7354 22.6349 27.2275 20.9947 27.2275H9.84127C8.20106 27.2275 6.83422 26.7354 5.85009 25.806C4.86596 24.8219 4.3739 23.455 4.3739 21.7601V10.552C4.3739 8.91181 4.86596 7.54497 5.85009 6.56084C6.77954 5.63139 8.20106 5.13933 9.84127 5.13933H21.1041C22.7443 5.13933 24.1111 5.63139 25.0952 6.61552C26.0247 7.59964 26.5714 8.96649 26.5714 10.552V21.8148Z"
                                        fill="white"/>
                                    </svg>
                                      </a>
                                </span>
                    </p>
                </div>
            </BottomModal>


            <PreviewPage isPreviewIsOver={isPreviewIsOver && isFetchOver}/>
            <div className="backgroundContainer"></div>
            <div
                className={`topContent ${isSwiped ? "activeSec" : ""} ${window.location.pathname == "/menu" ? "active" : ""} `}>
                <div className="menu" onClick={() => {
                    setSidebarIsOpen(true)
                }}>
                    <svg width="39" height="34" viewBox="0 0 39 34" fill="none">
                        <g filter="url(#filter0_d_322_53)">
                            <path
                                d="M4 10H28C29.104 10 30 9.104 30 8C30 6.896 29.104 6 28 6H4C2.896 6 2 6.896 2 8C2 9.104 2.896 10 4 10ZM28 14H4C2.896 14 2 14.896 2 16C2 17.104 2.896 18 4 18H28C29.104 18 30 17.104 30 16C30 14.896 29.104 14 28 14ZM28 22H4C2.896 22 2 22.896 2 24C2 25.104 2.896 26 4 26H28C29.104 26 30 25.104 30 24C30 22.896 29.104 22 28 22Z"
                                fill="white"/>
                        </g>
                        <defs>
                            <filter id="filter0_d_322_53" x="0" y="0" width="41" height="40"
                                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                <feColorMatrix in="SourceAlpha" type="matrix"
                                               values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                <feOffset dx="5" dy="4"/>
                                <feGaussianBlur stdDeviation="2"/>
                                <feComposite in2="hardAlpha" operator="out"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_322_53"/>
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_322_53"
                                         result="shape"/>
                            </filter>
                        </defs>
                    </svg>
                </div>
                <div className="menuContainer">
                    <button onClick={() => {
                        navigate("/");
                        setTimeout(() => {
                            scrollToElement("textContainerId");
                        }, 500);
                        setTimeout(() => {
                            setIsSwiped(true);
                        }, 1500);

                    }}>درباره ما
                    </button>
                    <button onClick={() => {
                        if (window.location.pathname != "/menu") {
                            navigate("/");
                            setTimeout(() => {
                                scrollToElement("menuContainerId");
                            }, 500);
                            setTimeout(() => {
                                setIsSwiped(true);
                            }, 1500);
                        }
                    }}>منو
                    </button>
                    <button onClick={() => {
                        navigate("/");
                        setTimeout(() => {
                            scrollToElement("conractUsId");
                        }, 500);
                        setTimeout(() => {
                            setIsSwiped(true);
                        }, 1500);

                    }}>تماس با ما
                    </button>
                    <button onClick={() => {
                        navigate("/");
                        setTimeout(() => {
                            scrollToElement("galleryContainerId");
                        }, 500);
                        setTimeout(() => {
                            setIsSwiped(true);
                        }, 1500);

                    }}>تصاویر
                    </button>
                </div>
                <div className="logo"></div>
            </div>

            <Routes>
                <Route
                    element={
                        <Suspense fallback={<LoadingSpinner/>}>
                            <HomePage swiperRef={swiperRef} onSetIsSwiped={setIsSwiped}
                                      onSetIsFetchOver={setIsFetchOver}/>
                        </Suspense>
                    }
                    exact
                    path="/"
                />
                <Route
                    element={
                        <Suspense fallback={<LoadingSpinner/>}>
                            <MenuPage swiperRef={swiperRef} onSetIsSwiped={setIsSwiped}
                                      onSetIsFetchOver={setIsFetchOver}/>
                        </Suspense>
                    }
                    exact
                    path="/menu"
                />
                <Route path="*" element={<Navigate to="/" replace/>}/>
            </Routes>

            {/*<div className="bottomNav">*/}
            {/*    <button className="menuBtn">*/}
            {/*        منو*/}
            {/*    </button>*/}
            {/*    <button className="evaluationBtn">*/}
            {/*        نظرسنجی*/}
            {/*    </button>*/}
            {/*</div>*/}
        </div>
    );
}

export default Container;
